<template>
<div>
    <h4>{{ statistic }}</h4>
    <Line-Chart
        v-if="loaded"
         :chart-data="chartData"
    >
    </Line-Chart>
</div>
</template>

<script>
import LineChart from '@/components/Charts/LineChart';

export default {
  components: {
    LineChart,
  },
  name: 'StatisticWidget',
  props: {
    statistic: {
      type: String,
      required: true,
    },
    chartData: {
      required: true,
    },
    loaded: {
      default: true,
    },
  },
};
</script>

<style scoped>

</style>
